<template>
  <div>
    <DeleteModal modalId="modal-delete" @deleteToggle="deleteItem" />

    <b-modal
      :no-close-on-backdrop="true"
      id="modal-edit"
      ok-only
      centered
      size="lg"
      :title="
        createMode
          ? `${$t('common.create')} ${$t('warehouse.sub-category')}`
          : `${$t('common.edit')} ${$t('warehouse.sub-category')}`
      "
    >
      <b-card-text>
        <b-row>
          <b-col md="">
            <b-form-group :label="$t('common.name')" label-for="name">
              <b-form-input
                v-model="EditForm.name"
                :placeholder="$t('common.name')"
              />
              <p class="text-danger mt-1">{{ errorForm.name }}</p>
            </b-form-group>
          </b-col>
          <b-col md="">
            <b-form-group
              v-if="createMode"
              :label="$t('warehouse.one-category')"
              label-for="name"
            >
              <b-form-input
                disabled
                v-model="currentCategory.name"
                :placeholder="$t('warehouse.one-category')"
              />
            </b-form-group>
            <AutoComplete
              v-else
              label="Parent"
              placeholder="Select Parent"
              v-model="EditForm.parent_id"
              param-query="search"
              :serializer="(val) => val.id"
              endpoint="category"
              text-title="name"
            />
          </b-col>
        </b-row>
      </b-card-text>
      <template #modal-footer="{}">
        <b-button variant="primary" @click="submitItem" class="m-0" :disabled="loading" ref="button" block>
          <span v-if="!loading">{{ $t('common.add') }}</span>
          <b-spinner small v-else></b-spinner>
        </b-button>
      </template>
    </b-modal>
    <b-card :title="$t('warehouse.sub-categories')">
      <div>
        <!-- Search Button -->

        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>{{ currentCategory.name }}</h2>
          <b-button variant="primary" @click="show(EditForm, 'create')">
            {{ $t('common.create') }} {{ $t('warehouse.one-category') }}
          </b-button>
        </div>

        <b-table
          fixed
          :items="this.data"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
          v-if="!loading"
        >
          <template #cell(has_sub-category)="data">
            <div class="d-flex">
              <b-badge
                class="cursor-pointer"
                variant="success"
                v-if="data.item.childs.length !== 0"
                @click="
                  $router.push({
                    name: 'subcategory',
                    params: { id: data.item.id, name: data.item.name },
                  })
                "
              >
                {{ $t('warehouse.see-sub-category') }}</b-badge
              >
              <b-badge v-else variant="danger">{{
                $t('warehouse.no-sub')
              }}</b-badge>
            </div>
          </template>
          <template #cell(has_items)="data">
            <div class="d-flex">
              <b-badge
                class="cursor-pointer"
                variant="success"
                v-if="data.item.items.length !== 0"
                @click="
                  $router.push({
                    name: 'item',
                    params: { id: data.item.id, name: data.item.name },
                  })
                "
              >
                {{ $t('warehouse.see-items') }}</b-badge
              >
              <b-badge v-else variant="danger">
                {{ $t('warehouse.no-items') }}</b-badge
              >
            </div>
          </template>
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="d-flex">
              <ActionsButtons
                deletePerm="delete-category"
                editPerm="update-category"
                @editToggle="show(data.item)"
                @deleteToggle="deleteModel(data.item)"
              />
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner :label="$t('common.loading')" />
            </div>
          </div>
        </template>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BSpinner,
  BLink,
  BBadge,
} from 'bootstrap-vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import StatisticCardHorizontal from '@core/components/statistics-cards/StatisticCardHorizontal.vue';
const AutoComplete = () => import('@/components/common/AutoComplete.vue');
import ActionsButtons from '@/components/common/ActionsButtons.vue';
import DeleteModal from '@/components/modals/DeleteModal.vue';
export default {
  components: {
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BLink,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BSpinner,
    StatisticCardHorizontal,
    AutoComplete,
    BBadge,
    ActionsButtons,
    DeleteModal,
  },
  data() {
    return {
      take: 10,
      loading: true,
      isNotValid: false,
      currentCategory: {},
      dataCount: 0,
      data: [],
      EditForm: {
        name: '',
        parent_id: '',
        _method: 'PUT',
      },
      createMode: false,
      errorForm: {
        name: '',
        parent_id: '',
      },
      params: {
        form: {},
        path: '',
      },
      tableColumns: [
        { key: 'name', label: this.$t('common.name'), sortable: true },
        {
          key: 'has_sub-category',
          label: this.$t('warehouse.has-sub'),
          sortable: true,
        },
        {
          key: 'has_items',
          label: this.$t('warehouse.has-items'),
          sortable: true,
        },

        { key: 'Actions', label: this.$t('common.actions') },
      ],

      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: '',
      sortBy: 'id',
      isSortDirDesc: true,
      page: 1,
    };
  },
  watch: {
    // Watching $route object to detect changes in route parameters
    $route(to, from) {
      // React to route changes here
      // You can access the route parameters via `to.params`
      // For example, if you're watching for changes to a parameter named 'id':
      if (to.params.id !== from.params.id) {
        this.getSubCategoriesList();
      }
    },
  },
  mounted() {
    this.getSubCategoriesList();
  },
  methods: {
    show(item, mode) {
      if (mode === 'create') {
        this.createMode = true;
        this.EditForm = {
          name: '',
          parent_id: this.$route.params.id,
          _method: 'POST',
        };
      } else {
        this.createMode = false;

        this.EditForm.id = item.id;
        this.EditForm.name = item.name;
        this.EditForm.parent_id = item.parent_id;
        this.EditForm._method = 'PUT';
      }
      this.$bvModal.show('modal-edit');
    },
    showPhoneObj(obj, countryCallingCodeCheck) {
      this.isNotValid = !obj.isValid;
      countryCallingCodeCheck
        ? (this.countryCallingCodeFirst = obj.countryCallingCode)
        : (this.countryCallingCodeSecond = obj.countryCallingCode);
    },
    async getSubCategoriesList() {
      this.loading = true;

      let url = `/category/${
        this.$route.params.id ? this.$route.params.id : this.currentCategory.id
      }`;

      await this.getList(url);
      this.currentCategory = this.all_data;

      this.data = this.all_data.childs;
      this.loading = false;
    },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show('modal-delete');
    },
    deleteItem() {
      this.$store
        .dispatch('delete', `/category/${this.deleteForm.id}`)
        .then((response) => {
          if (this.data.length === 0) {
            this.$router.push('category');
          }
          this.getSubCategoriesList();

          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Delete Success',
              icon: 'success',
              variant: 'info',
              text: 'deleted ' + this.deleteForm.first_name + ' successfully',
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Error',
              variant: 'danger',
              text: 'Error deleting ' + this.deleteForm.first_name,
            },
          });
        });
    },
    submitItem() {
      this.loading = true;
      this.errorForm.name = '';
      for (let item in this.errorForm) {
        this.errorForm[item] = '';
        if (this.EditForm[item] == '' || this.EditForm[item] == null)
          delete this.EditForm[item];
      }
      if (!this.EditForm.name) {
        this.errorForm.name = 'The name field is required.';
        this.loading = false;
        return false;
      }

      if (this.createMode) {
        (this.params.form = this.EditForm),
          (this.params.path = `/category`),
          this.$store
            .dispatch('create', this.params)
            .then((response) => {
              this.getSubCategoriesList();
              this.loading = false;
              this.$bvModal.hide('modal-edit');
            })
            .catch((error) => {
              this.loading = false;
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: 'validation error',
                      variant: 'danger',
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        if (!this.EditForm.parent_id) {
          delete this.EditForm.parent_id;
        }
        (this.params.form = this.EditForm),
          (this.params.path = `/category/${this.EditForm.id}`),
          this.$store
            .dispatch('update', this.params)
            .then((response) => {
              this.loading = false;
              this.$bvModal.hide('modal-edit');
              if (this.data.length === 0) {
                this.$router.push('category');
              }
              this.getSubCategoriesList();
            })
            .catch((error) => {
              this.loading = false;
              console.log(error);
            });
      }
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
